export const WEB_ACTION_INTEREST_DIALOG_URL = 'web.action.interestDialog.url';
export const FOLLOW_BUTTON_LABEL_TRANSLATION_KEY =
  'interest.selection.submit.button.label.translation.key';
export const UNFOLLOW_BUTTON_LABEL_TRANSLATION_KEY =
  'interest.selection.unfollow.button.label.translation.key';
